import { render } from "./ent_diagnosis.vue?vue&type=template&id=4e036378&scoped=true"
import script from "./ent_diagnosis.vue?vue&type=script&lang=js"
export * from "./ent_diagnosis.vue?vue&type=script&lang=js"

import "./ent_diagnosis.vue?vue&type=style&index=0&id=4e036378&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e036378"]])

export default __exports__